import { Chock } from "@/pages/catalogs/models/Chock";
import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

const moment = getMomentTz();

export const getChocks = async (
	params: { partId: number },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartId", value: params.partId }];

	const resp = await apiService.callV2("[M2].[GetChocks]", parameters, signal);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as Chock[];
		rows = rows.map((chock: Chock) => ({
			...chock,
			RebuildTimestamp: chock.RebuildTimestamp
				? moment.utc(chock["RebuildTimestamp"]).toDate()
				: null,
			BearingChangeTimestamp: chock.BearingChangeTimestamp
				? moment.utc(chock["BearingChangeTimestamp"]).toDate()
				: null,
		}));

		return rows;
	} else {
		throw new Error(resp.message || "Error fetching chock");
	}
};
